import type { HrContext } from '../services/context';

let runtimeContext: HrContext | undefined;
const listeners = new Set<() => void>();

export const setHrRuntimeContext = (context?: HrContext) => {
  runtimeContext = context;
  listeners.forEach((listener) => {
    listener();
  });
};

export const getHrRuntimeContext = () => runtimeContext;

export const subscribeHrRuntimeContext = (listener: () => void) => {
  listeners.add(listener);
  return () => {
    listeners.delete(listener);
  };
};

export const getHrRuntimePermissions = (hasCurrentUser?: boolean) => {
  return hasCurrentUser ? ['*'] : undefined;
};

export const getHrRuntimePermissionKey = (hasCurrentUser?: boolean) => {
  const permissions = getHrRuntimePermissions(hasCurrentUser);
  if (!permissions) {
    return 'anonymous';
  }
  return permissions.join('|') || 'empty';
};
